import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { IAdvanceSearch } from 'src/app/common/models/IAdvanceSearch';
import { ClearAdvanceSearch, SetAdvanceSearchData } from './advance-search.actions';

export class AdvanceSearchStateModel {
    advanceSearch: IAdvanceSearch;
}

@State<AdvanceSearchStateModel>({
    name: 'advanceSearch',
    defaults: {
        advanceSearch: null
    }
})

@Injectable()
export class AdvanceSearchState {

    @Selector()
    static getAdvanceSearchState(state: AdvanceSearchStateModel) {
        return state;
    }

    @Action(SetAdvanceSearchData)
    public setAdvanceSearch({ getState, setState }: StateContext<AdvanceSearchStateModel>,
       { advanceSearch }: SetAdvanceSearchData) {
        const state = getState();
        setState({ ...state, advanceSearch });
    }

    @Action(ClearAdvanceSearch)
    public clearAdvanceSearch({ getState, setState }: StateContext<AdvanceSearchStateModel>) {
        const state = getState();
        setState({ ...state, advanceSearch: null });
    }
}
